import React, { Component } from 'react';
import config from 'react-global-configuration';

class CalendarDay extends Component {


  render() {
    return (
<div>
  {this.props.daily_schedules.map(function(daily_schedule, linha) {
    return (
      <p className="link-daily" style={{background: daily_schedule['background'], color: daily_schedule['color']}}>{daily_schedule['text']}</p>
    );
  })}
  {this.props.base_schedules.map(function(base_schedule, linha) {
    return (
      <p className="link-bases" style={{background: base_schedule['background'], color: base_schedule['color']}}>{base_schedule['text']}</p>
    );
  })}
  {this.props.training_schedules.map(function(training_schedule, linha) {
    return (
      <p className="link-trainings">{training_schedule}</p>
    );
  })}
  {this.props.mission_schedules.map(function(mission_schedule, linha) {
    return (
      <p className="link-missions" style={{background: mission_schedule['background'], color: mission_schedule['color']}}>{mission_schedule['text']}</p>
    );
  })}
  {this.props.team_schedules.map(function(team_schedule, linha) {
    return (
      <p className="link-teams">{team_schedule}</p>
    );
  })}
</div>
    );
  }
}

export default CalendarDay;



// WEBPACK FOOTER //
// ./src/Components/Calendar/Elements/CalendarDayTeam.js